
import React from 'react';
import TypingTest from './games/TypingTest';
import MemoryGame from './games/MemoryGame';
import QuizGame from './games/QuizGame';
import MathChallenge from './games/MathChallenge';
import ReactionTest from './games/ReactionTest';
import CodeGuess from './games/CodeGuess';
import BinaryGame from './games/BinaryGame';
import HangmanGame from './games/HangmanGame';
import LogicGrid from './games/LogicGrid';
import PixelDraw from './games/PixelDraw';
import PathFinder from './games/PathFinder';
import WordShuffle from './games/WordShuffle';
import ColorMatch from './games/ColorMatch';
import EmojiMemory from './games/EmojiMemory';
import SyntaxFix from './games/SyntaxFix';
import RegexQuiz from './games/RegexQuiz';
import AITrivia from './games/AITrivia';
import CryptoPuzzle from './games/CryptoPuzzle';
import MorseTrainer from './games/MorseTrainer';
import SequenceGame from './games/SequenceGame';
import SortingChallenge from './games/SortingChallenge';
import APIQuiz from './games/APIQuiz';
import BrainTeaser from './games/BrainTeaser';
import SpaceClicker from './games/SpaceClicker';

const games = {
    1: <TypingTest />,
    2: <MemoryGame />,
    3: <QuizGame />,
    4: <MathChallenge />,
    5: <ReactionTest />,
    6: <CodeGuess />,
    7: <BinaryGame />,
    8: <HangmanGame />,
    9: <LogicGrid />,
    10: <PixelDraw />,
    11: <PathFinder />,
    12: <WordShuffle />,
    13: <ColorMatch />,
    14: <EmojiMemory />,
    15: <SyntaxFix />,
    16: <RegexQuiz />,
    17: <AITrivia />,
    18: <CryptoPuzzle />,
    19: <MorseTrainer />,
    20: <SequenceGame />,
    21: <SortingChallenge />,
    22: <APIQuiz />,
    23: <BrainTeaser />,
    24: <SpaceClicker />
};

const DailyGame = ({ day }) => games[day] || (
    <p style={{ textAlign: 'center', color: '#cbd5e1', fontSize: '0.8rem', marginTop: '0.8rem' }}>
        <i className="fas fa-brain" style={{ marginRight: '6px' }}></i> La sfida interattiva sarà disponibile nei prossimi giorni.
    </p>
);

export default DailyGame;
